import * as apiService from "./v2/apiService";
import { apiCallWithoutToken } from "./apiService";
import { baseURL } from "@/constants/v2/endPoints";

const PUBLIC_URL = `${baseURL}api/v2/public`;
const DEMAND_URL = `${baseURL}api/v2/demand`;

export const checkDemand = (showcaseKey, body) =>
  apiCallWithoutToken(`${PUBLIC_URL}/showcase/${encodeURIComponent(showcaseKey)}/demand-check`, "POST", body);

export const requestDemandDetails = (showcaseKey, body) =>
  apiCallWithoutToken(`${PUBLIC_URL}/showcase/${encodeURIComponent(showcaseKey)}/demand-check/request`, "POST", body);

export const confirmDemandDetails = (token) =>
  apiCallWithoutToken(`${PUBLIC_URL}/demand-check/confirm`, "POST", { token });

export const getPropertyDemandLink = (token) =>
  apiCallWithoutToken(`${PUBLIC_URL}/demand-links/${encodeURIComponent(token)}`, "GET");

export const getInventoryDemandLink = (inventoryId) =>
  apiService.apiCall(`${DEMAND_URL}/inventory/${Number(inventoryId)}/link`, "GET", {});

export const createInventoryDemandLink = (inventoryId) =>
  apiService.apiCall(`${DEMAND_URL}/inventory/${Number(inventoryId)}/link`, "POST", {});

export const revokeInventoryDemandLink = (inventoryId) =>
  apiService.apiCall(`${DEMAND_URL}/inventory/${Number(inventoryId)}/link`, "DELETE", {});

export const getAddressDemandReport = (address) =>
  apiService.apiCall(`${DEMAND_URL}/address?address=${encodeURIComponent(address)}`, "GET", {});
